export default __webpack_public_path__ + "images/0x15b2fb8f08e4ac1ce019eadae02ee92aedf06851.png";